<template>
  <div class="btn_icon" :style="btnStyles" @click="onClick">
    <template v-if="url_image">
      <img :src="iconUrl" class="img_icon" />
    </template>
    <template v-else>
      <img :src="require(`@/assets/images/CH2/${iconUrl}`)" class="img_icon" />
    </template>
  </div>
</template>

<script>
export default {
  name: "Button_Icon",
  props: {
    iconUrl: {
      type: String,
    },
    url_image: {
      type: Boolean,
      default: true,
    },
    bgColor: {
      type: String,
    },
    size: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  methods: {
    onClick: function (e) {
      this.$emit("click", e);
    },
  },
  computed: {
    btnStyles() {
      return {
        "background-color": this.bgColor,
      };
    },
    // used for detect data, in this project usually detect the response data from API
    // that collect in the getters of store (vuex)
    // bringing mapGetters to detect in getters of store (vuex)
    // syntax : ...mapGetters({ Name created variable for local data : Name of getters in store })
    // Example => ...mapGetters({ courses : 'courses/allCourses' })
  },
  watch: {
    // used to manage data after detect data
    // Syntax : Existing name of local variable : function(value){ Action }
    // Example => course : function(value){ this.data = value }
    // Value in parameter is the value of detected data changing
  },
  created() {
    // used for manage event when this page open
  },
  mounted() {
    // used for manage event when data has changed
  },
  beforeDestroy() {
    // used for update value before close this page
    // สมมติว่าจับเวลาใช้ในหน้านี้กี่นาที ให้มาเก็บในนี้
  },
};
</script>

<style scoped>
.btn_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px;
  width: 100%;
  height: 100%;
  padding-bottom: 0px;
  border-radius: 8px;
  cursor: pointer;
}
.img_icon {
  width: 50%;
  height: 50%;
}
</style>